import { DefaultService } from '@/services/DefaultService';

export default class AssUsuarioCampanhaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAllByGrupo(idgrupo, page = 0, limit = 50, order = 'asc', column = 'descricao', situacao = 2, ...param) {
        return this._http.get(encodeURI(`${this._env}/ven/grupo-produto/getallbyidgrupo/${idgrupo}.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    save(gruposSelecionados) {
        return this._http.post(`${this._env}/ven/grupo-produto/`, gruposSelecionados, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    updateSituacao(campanha) {
        return this._http.post(`${this._env}/ven/grupo-produto/updatesituacao`, campanha, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }
}